import React from 'react';
import { StackScreen, Typography, ScrollView, Flex } from '@banhala/ui-kit';

export const LikeScreen: React.FC = () => {
  return (
    <StackScreen title={'찜'} hideBackButton={true}>
      <ScrollView style={{ flex: 1 }}>
        <Flex height={500} alignItems={'center'} justifyContent={'center'}>
          <Typography>찜탭</Typography>
        </Flex>
      </ScrollView>
    </StackScreen>
  );
};
